import Sidebar from "../components/Sidebar";
import { Header } from "../components/header";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { InsuranceDashboard } from "../components/insurance-dashboard.component";


export function HealthInsuranceDashboardPage() {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <div className="dashboard-page">

            <div className="dashboard-layout">
                <Sidebar
                    activeItemId="health-and-insurance"
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                <div className="dashboard-main-content">
                    <Header
                        setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className='py-0 px-sm-3'>
                        <InsuranceDashboard  />
                    </div>
                </div>
            </div>
        </div>
    );
}
